import React, { Component } from 'react'

import get from 'lodash/get'
import includes from 'lodash/includes'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { reset } from 'redux-form'

import interestArray from '../../../assets/interests/interestsArray.json'

import * as userProfileDuck from '../../../routes/authenticated/UserProfile/userProfileDuck'
import * as currentUserDuck from '../../../store/shared/currentUserDuck'
import selectors from '../../../store/shared/selectors'
import { getRootFromInsToken } from '../../../utils/string'

import InterestOption from './InterestOption'
import * as interestSelectorDuck from './interestSelectorDuck'
import sendFullStoryEvent from '../../../utils/analyticsHelpers/sendFullStoryEvent'
import fullstory from '../../../utils/constants/fullstory'

/**
 * @class InterestSelectorCard
 * @description Select and modify interest
 */
export class InterestSelectorCard extends Component {
  /**
   * @static propTypes
   */
  static propTypes = {
    currentUser: PropTypes.any.isRequired,
    currentUserSuccess: PropTypes.func.isRequired,
    handleInterestSelectionDone: PropTypes.func.isRequired,
    interestsCount: PropTypes.number.isRequired,
    onClickOption: PropTypes.func.isRequired,
    performUpdateUserProfile: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    selectedOptions: PropTypes.array.isRequired,
    getFeedsData: PropTypes.func.isRequired,
  }

  /**
   * @constructor
   * @param props
   */
  constructor(props) {
    super(props)

    /**
     * @method updateInterests
     * @param interests
     */
    this.updateInterests = interests =>
      this.props
        .performUpdateUserProfile({ interests })
        .then(({ user }) => {
          const insToken = getRootFromInsToken(get(user, 'insToken', ''))
          const interests = get(user, 'interests') ? user.interests : []
          this.props.currentUserSuccess(user)
          this.props.reset('feedSearchForm')
          this.props.getFeedsData({
            page: 1,
            searchTerm: interests,
            insToken,
            onlyInterestsSearch: true,
          })
          this.props.handleInterestSelectionDone()

          const eventProperties = {
            interests_strs: interests,
          }
          sendFullStoryEvent(fullstory.eventNames.selectInterests, eventProperties)
        })
        .catch(() => {})
  }

  componentWillMount() {
    this.props.currentUserSuccess(this.props.currentUser)
  }

  /**
   * @method render
   */
  render() {
    const {
      handleInterestSelectionDone,
      interestsCount,
      onClickOption,
      selectedOptions,
    } = this.props

    const notEnoughInterests = selectedOptions && selectedOptions.length < 1

    return (
      <div className="text-center" style={{ overflowY: 'auto', height: '100%' }}>
        <div style={{ position: 'relative' }}>
          <h4>Ready to build your feed?</h4>
          <h5 className="text-muted">
            <strong>Select 1 or more</strong> interests so we can show relevant content in your
            feed.
          </h5>
          {interestsCount >= 1 && (
            <i
              className="fal fa-times"
              style={{
                position: 'absolute',
                right: 0,
                top: 0,
                fontSize: 20,
                cursor: 'pointer',
              }}
              onClick={() => handleInterestSelectionDone()}
            />
          )}
        </div>
        {interestArray.map(interest => (
          <InterestOption
            key={interest.name}
            data={interest}
            onClick={() => onClickOption(interest.name)}
            isSelected={selectedOptions && includes(selectedOptions, interest.name)}
          />
        ))}
        <div
          style={{
            paddingTop: 10,
            paddingBottom: 10,
          }}
        >
          <button
            className="btn btn-success btn-lg"
            disabled={notEnoughInterests}
            onClick={() => this.updateInterests(selectedOptions)}
            style={{ minWidth: 200 }}
          >
            Done
          </button>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  currentUser: selectors.getCurrentUser(state),
  interestsCount: selectors.getInterestsCount(state),
  selectedOptions: interestSelectorDuck.getSelectedOptions(state),
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      currentUserSuccess: currentUserDuck.currentUserSuccess,
      onClickOption: interestSelectorDuck.toggleOption,
      performUpdateUserProfile: userProfileDuck.performUpdateUserProfile,
      reset,
    },
    dispatch,
  )

export default connect(mapStateToProps, mapDispatchToProps)(InterestSelectorCard)



// WEBPACK FOOTER //
// ./src/components/ui/InterestSelector/InterestSelectorCard.js